import BaseHandler from "../BaseHandler";
import store from "../../store";
import { setStoriesList, updateStoriesList } from "../../store/stories/actions";
import { StoryUserAddNewResponse } from "../../proto/StoryUserAddNew_pb";

export default class HandleStoryUserAddNewResponse extends BaseHandler<StoryUserAddNewResponse> {
  handle() {
    const getStoryUserAddNewResponse = this.response.toObject();

    if (getStoryUserAddNewResponse.storyList) {
      const userId = getStoryUserAddNewResponse.storyList[0].userId || getStoryUserAddNewResponse.storyList[0].roomId;
      store.dispatch(updateStoriesList({ originatorId: userId, story: getStoryUserAddNewResponse.storyList }));
    }
  }
}
